"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.baseMediaEditMarketStrategy = void 0;
const vehicleKey_1 = require("../../../utils/vehicleKey");
const vehicleType_1 = require("../../../utils/vehicleType");
const constants_1 = require("../../constants");
const mustacheRenderer_1 = require("../../renderer/mustacheRenderer");
const textResources_1 = require("../../textResources");
const utils_1 = require("../../utils");
const baseMediaEditMarketStrategy = ({ configurationDetails, locale, i18nlanguage }, output) => {
    const resources = new textResources_1.I18nText(locale, i18nlanguage);
    const vehicleType = (0, vehicleType_1.getVehicleTypeForConfigurationDetails)(configurationDetails);
    const vehicleKey = (0, vehicleKey_1.getVehicleKeyForConfigurationDetails)(configurationDetails);
    if (!vehicleType || !configurationDetails.techdata) {
        return output;
    }
    // Verbrauchswerte
    let consumptionCombinedFormattedText;
    const consumptionCombinedValue = (0, utils_1.formatConsumptionValueTextMediaEdit)(configurationDetails.techdata);
    if (consumptionCombinedValue) {
        consumptionCombinedFormattedText = (0, mustacheRenderer_1.substituteTemplate)(resources.get(`vue.consumption.combined.${vehicleKey}`), {
            consumption0: {
                fuel: (0, utils_1.getTechDataItem)("fuel-consumption", "fuel-type", configurationDetails.techdata),
                mediaedit: {
                    combined: {
                        formatted: consumptionCombinedValue,
                    },
                },
            },
            footnote: {
                reference: `{${constants_1.FOOTNOTE_REFERENCE}}`,
            },
        });
    }
    // CO2-Emission
    let emissionCombinedFormattedText;
    const emissionCombinedValue = (0, utils_1.formatEmissionValueTextMediaEdit)(configurationDetails.techdata);
    if (emissionCombinedValue) {
        emissionCombinedFormattedText = (0, mustacheRenderer_1.substituteTemplate)(resources.get(`vue.emission.combined.${vehicleKey}`), {
            emission: {
                mediaedit: {
                    combined: {
                        formatted: emissionCombinedValue,
                    },
                },
            },
            footnote: {
                reference: `{${constants_1.FOOTNOTE_REFERENCE}}`,
            },
        });
    }
    const ret = Object.assign(Object.assign({}, output), { formattedConsumption: consumptionCombinedFormattedText, formattedEmission: emissionCombinedFormattedText, hasNedc: false, hasWltp: false, vehicleType, footnote: {
            reference: constants_1.FOOTNOTE_REFERENCE,
        } });
    return ret;
};
exports.baseMediaEditMarketStrategy = baseMediaEditMarketStrategy;
